var _linearGradient, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlockchainCertificate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 60,
    viewBox: "0 0 60 60",
    width: 60,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 30,
    x2: 30,
    y1: 0,
    y2: 60
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e74bc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d045eb"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#a)",
    height: 60,
    rx: 16,
    width: 60
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.334 37.1248 8.6667 4.8747 5.3333-3 3.3333-1.8754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.6673 34.0001v-10l-8.3333-4.6874"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.6673 19.3127-8.3333 4.6874v10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 26.4992-2 1.1667v4.6666l2 1.1667 2 1.1666 2-1.1666 2-1.1667v-4.6666l-2-1.1667-2-1.1667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 25.3329v-4.6666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34 32 4.6667 2.6667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.0007 32-4.6667 2.6667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 20.6663c1.1046 0 2-.8955 2-2 0-1.1046-.8954-2-2-2s-2 .8954-2 2c0 1.1045.8954 2 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.334 38c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.668 38c1.1045 0 2-.8954 2-2s-.8955-2-2-2c-1.1046 0-2 .8954-2 2s.8954 2 2 2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockchainCertificate);
export default __webpack_public_path__ + "static/media/blockchain-certificate.c51e254c.svg";
export { ForwardRef as ReactComponent };